var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManualIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 42,
    viewBox: "0 0 34 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.844 6.6331V2.21129H4.4383C3.21101 2.21129 2.21877 3.19917 2.21877 4.42258C2.21877 5.64599 3.21101 6.63387 4.4383 6.63387H28.844V6.6331ZM32.9569 6.95401C33.1552 7.15524 33.2822 7.43118 33.2822 7.73684V40.8963C33.2822 41.5038 32.7846 42 32.1706 42H4.4383C1.98678 42 0 40.0197 0 37.5774V4.42258C0 1.97956 1.98678 0 4.4383 0H29.9518C30.5658 0 31.0635 0.496225 31.0635 1.10374V6.6331H32.1713C32.4783 6.6331 32.7555 6.75583 32.9576 6.95401H32.9569ZM31.0635 8.84058H4.4383C3.6298 8.84058 2.87031 8.62791 2.21877 8.25136V37.5774C2.21877 38.8001 3.21101 39.7887 4.4383 39.7887H31.0635V8.84058Z",
    fill: "#061A42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1254 18.7733C17.3007 18.7733 18.2519 17.827 18.2519 16.6555C18.2519 15.484 17.3007 14.5376 16.1254 14.5376C14.9501 14.5376 13.9941 15.486 13.9941 16.6555C13.9941 17.8249 14.9481 18.7733 16.1254 18.7733Z",
    fill: "#FFCC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2651 29.7556C21.2651 29.044 20.6904 28.463 19.9681 28.463H18.5598V21.6803C18.5598 21.2306 18.1915 20.8544 17.7296 20.8544H15.34C14.4086 20.8544 13.6877 21.5735 13.6877 22.4606C13.6877 23.3477 14.4086 24.0648 15.3004 24.0648H15.8545L15.9017 24.6159V28.4637H14.4086C13.6952 28.4637 13.1096 29.0447 13.1096 29.7563V31.1176H21.2651V29.7563",
    fill: "#FFCC00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualIcon);
export default __webpack_public_path__ + "static/media/manual-icon.d89688c9edff7bf1472093f9fcaee9f7.svg";
export { ForwardRef as ReactComponent };